import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faEdit, faTimes, faMapMarkerAlt, faTrash } from '@fortawesome/free-solid-svg-icons';
import { getCustomersData, getSection } from './saleReportHelpers';
import CustomerLink from '../../../Components/CustomerLink';
import SaleCreditCell, { useReportCredit } from '../SaleCreditControl';

// รายการขาย — paperless edit. `salesRows` is the container's single FORGOT-sentinel
// filter (customerId !== 'FORGOT'), passed down rather than re-filtered here so this
// tab and ForgotSaleTab can't drift apart on what counts as a "normal" sale row.
const SalesRowsTab = ({
    fullReport,
    reportCode,
    salesRows,
    deliveryCheckerData,
    editSaleMsdUid,
    setEditSaleMsdUid,
    editSaleCode,
    setEditSaleCode,
    deletingSaleMsdUid,
    salesListExpanded,
    setSalesListExpanded,
    loadingSalesList,
    handleRecodeSale,
    handleDeleteSale,
}) => {
    const master = getSection(fullReport, ['master', 'masterReport', 'report', 'masterData'], null);
    const isVerified = master?.verified === true;
    const credit = useReportCredit(reportCode);
    // Build customerId → customerName map from fullReport customer data
    const customerNameMap = {};
    const { list: custList } = getCustomersData(fullReport);
    custList.forEach(c => { if (c.customerId) customerNameMap[c.customerId] = c.customerName || c.shopName || ''; });
    // Also include deliveryCheckerData names
    deliveryCheckerData.forEach(c => { if (c.customerId && !customerNameMap[c.customerId]) customerNameMap[c.customerId] = c.customerName || c.shopName || ''; });

    return (
        <div className="btc-section" style={{ gridColumn: 'span 2' }}>
            <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px', cursor: 'pointer' }}
                onClick={() => setSalesListExpanded(v => !v)}
            >
                <h3 style={{ margin: 0 }}>รายการขาย ({salesRows.length} รายการ)</h3>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {isVerified && (
                        <span style={{ background: '#dc3545', color: '#fff', borderRadius: '6px', padding: '3px 10px', fontSize: '13px' }}>
                            ตรวจสอบแล้ว — ไม่สามารถแก้ไขได้
                        </span>
                    )}
                    <span style={{ fontSize: '13px', color: '#495057' }}>{salesListExpanded ? '▲ ย่อ' : '▼ ขยาย (แก้ไข)'}</span>
                </div>
            </div>
            {salesListExpanded && loadingSalesList && <p>กำลังโหลดรายการขาย...</p>}
            {salesListExpanded && !loadingSalesList && salesRows.length > 0 && (
                <table className="btc-table" style={{ fontSize: '13px' }}>
                    <thead>
                        <tr>
                            <th>เวลา</th>
                            <th>ชื่อลูกค้า</th>
                            <th>พิกัด</th>
                            <th>คนขาย</th>
                            <th>saleCode</th>
                            <th>จำนวน</th>
                            <th>ยอด (฿)</th>
                            <th>ค้าง</th>
                            {!isVerified && <th>แก้ไข</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {salesRows.map((sale) => (
                            <tr key={sale.msdUid}>
                                <td>{sale.time ? sale.time.substring(0, 8) : ''}</td>
                                <td>{sale.customerId ? <CustomerLink name={customerNameMap[sale.customerId]} code={sale.customerId} /> : '-'}</td>
                                <td>
                                    {sale.latitude != null && sale.longitude != null ? (
                                        <button
                                            className="btc-btn btn-sm"
                                            style={{ backgroundColor: '#6c757d', padding: '3px 8px', fontSize: '11px' }}
                                            onClick={() => window.open(`https://www.google.com/maps?q=${sale.latitude},${sale.longitude}`, '_blank')}
                                        >
                                            <FontAwesomeIcon icon={faMapMarkerAlt} /> {sale.latitude.toFixed(4)}, {sale.longitude.toFixed(4)}
                                        </button>
                                    ) : '-'}
                                </td>
                                <td>{fullReport?.masterReport?.sellerName || sale.sellerId}</td>
                                <td>
                                    {editSaleMsdUid === sale.msdUid ? (
                                        <input
                                            type="text"
                                            value={editSaleCode}
                                            onChange={e => setEditSaleCode(e.target.value)}
                                            placeholder="เช่น 1I40B3P-2I40B2P"
                                            style={{ width: '180px', padding: '3px 6px', borderRadius: '4px', border: '1px solid #007bff' }}
                                            autoFocus
                                        />
                                    ) : (
                                        <code style={{ fontSize: '12px' }}>{sale.saleCode}</code>
                                    )}
                                </td>
                                <td>{sale.quantity}</td>
                                <td>{Number(sale.total).toLocaleString()}</td>
                                <td><SaleCreditCell sale={sale} customerName={customerNameMap[sale.customerId]} isVerified={isVerified} credit={credit} /></td>
                                {!isVerified && (
                                    <td>
                                        {editSaleMsdUid === sale.msdUid ? (
                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                <button
                                                    className="btc-btn btn-sm"
                                                    style={{ backgroundColor: '#46af38', padding: '4px 8px' }}
                                                    onClick={() => handleRecodeSale(sale.msdUid, editSaleCode)}
                                                >
                                                    <FontAwesomeIcon icon={faSave} />
                                                </button>
                                                <button
                                                    className="btc-btn btn-sm"
                                                    style={{ backgroundColor: '#dc3545', padding: '4px 8px' }}
                                                    onClick={() => { setEditSaleMsdUid(null); setEditSaleCode(''); }}
                                                >
                                                    <FontAwesomeIcon icon={faTimes} />
                                                </button>
                                            </div>
                                        ) : (
                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                <button
                                                    className="btc-btn btn-sm"
                                                    style={{ backgroundColor: '#007bff', padding: '4px 8px' }}
                                                    onClick={() => { setEditSaleMsdUid(sale.msdUid); setEditSaleCode(sale.saleCode || ''); }}
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                                <button
                                                    className="btc-btn btn-sm"
                                                    style={{ backgroundColor: '#dc3545', padding: '4px 8px' }}
                                                    onClick={() => handleDeleteSale(sale.msdUid)}
                                                    disabled={deletingSaleMsdUid === sale.msdUid}
                                                    title="ลบรายการขายนี้ (กดผิด)"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {salesListExpanded && !loadingSalesList && salesRows.length === 0 && <p>ยังไม่มีรายการขายในรายงานนี้</p>}
        </div>
    );
};

export default SalesRowsTab;
